<template lang="html">
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <div v-on="on" style="float: left;">
          <v-btn
          :color="color"
          text
          :disabled="disabled"
          @click="click()"
          >
            <slot></slot>
          </v-btn>
        </div>
      </template>
      <span>
        <div v-if="disabled !== '' && !disabled">{{tooltip}}</div>
        <div v-else>{{disabledTooltip}}</div>
      </span>
    </v-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['tooltip', 'disabled-tooltip', 'disabled', 'color'],
    data: () => ({
      focus: false
    }),
    methods: {
      click () {
        this.$emit('click')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// c-hint-btn.vue?3e11c7e0